import { OnDestroy, Directive } from '@angular/core';
import { merge, Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SubscriptionBasedComponent } from './subscription-based.component';

@Directive()
export abstract class SubscriptionWithDestroyTriggerComponent
  extends SubscriptionBasedComponent
  implements OnDestroy {
  protected destroyThisComponent = new Subject<any>();

  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.destroyThisComponent.next();
    this.destroyThisComponent.complete();
  }

  createObservableUntilDestroy(
    ...observables: Observable<any>[]
  ): Observable<any> {
    if (observables == null) {
      return null;
    }
    if (observables.length === 1) {
      return observables[0].pipe(takeUntil(this.destroyThisComponent));
    }
    return merge(...observables).pipe(takeUntil(this.destroyThisComponent));
  }
}
